import {Component, Input, OnInit} from '@angular/core';
import {BaseComponent} from '../../../../shared/commons/base-component/base.component';
import {MovieItem} from '../../../../data/vod/models/movie-item';
import {HelpersService} from '../../../../core/helpers/helpers.service';
import { VodDataRestService } from '../../../../data/vod/vod-data-rest.service';

@Component({
  selector: 'app-video-selection',
  templateUrl: './video-selection.component.html',
  styleUrls: ['./video-selection.component.css']
})
export class VideoSelectionComponent extends BaseComponent implements OnInit {
  @Input() contentID: string;
  @Input() title: string;

  public data: Array<MovieItem>;
  public featuredItem: MovieItem;

  constructor(helpers: HelpersService, private dataSource: VodDataRestService) {
    super(helpers);
  }

  ngOnInit() {
    // this.dataSource.getContents(this.contentID).subscribe(data => {
    //   this.featuredItem = data[0];
    //   this.data = data.slice(1, 4);
    // });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/widgets/video-selection/video-selection.component.ts